import React from 'react';

const PaymentInfo = ({ formData, setFormData, errors = {} }) => {
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const paymentStatusOptions = [
    { value: 'pending', label: 'Beklemede' },
    { value: 'partial', label: 'Kısmi Ödendi' },
    { value: 'paid', label: 'Ödendi' },
    { value: 'refunded', label: 'İade Edildi' }
  ];

  const paymentMethodOptions = [
    { value: 'cash', label: 'Nakit' },
    { value: 'card', label: 'Kredi Kartı' },
    { value: 'bank_transfer', label: 'Banka Havalesi' },
    { value: 'online', label: 'Online Ödeme' },
    { value: 'agency_credit', label: 'Acente Kredisi' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-4">Ödeme Bilgileri</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Ödeme Durumu */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Ödeme Durumu *
            </label>
            <select
              value={formData.paymentStatus}
              onChange={(e) => handleInputChange('paymentStatus', e.target.value)}
              className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${
                errors.paymentStatus ? 'border-red-300' : 'border-gray-300'
              }`}
            >
              {paymentStatusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.paymentStatus && (
              <p className="mt-1 text-sm text-red-600">{errors.paymentStatus}</p>
            )}
          </div>

          {/* Ödeme Yöntemi */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Ödeme Yöntemi *
            </label>
            <select
              value={formData.paymentMethod}
              onChange={(e) => handleInputChange('paymentMethod', e.target.value)}
              className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${
                errors.paymentMethod ? 'border-red-300' : 'border-gray-300'
              }`}
            >
              {paymentMethodOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.paymentMethod && (
              <p className="mt-1 text-sm text-red-600">{errors.paymentMethod}</p>
            )}
          </div>

          {/* Ödenen Tutar */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Ödenen Tutar ({formData.currency})
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              max={formData.price}
              value={formData.paidAmount}
              onChange={(e) => handleInputChange('paidAmount', parseFloat(e.target.value) || 0)}
              className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${
                errors.paidAmount ? 'border-red-300' : 'border-gray-300'
              }`}
              placeholder="0.00"
            />
            {errors.paidAmount && (
              <p className="mt-1 text-sm text-red-600">{errors.paidAmount}</p>
            )}
            {formData.price && (
              <p className="mt-1 text-sm text-gray-500">
                Toplam tutar: {formData.price} {formData.currency}
              </p>
            )}
          </div>

          {/* Kalan Tutar (Hesaplanmış) */}
          {formData.price && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Kalan Tutar
              </label>
              <div className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-md text-gray-700">
                {(parseFloat(formData.price) - parseFloat(formData.paidAmount || 0)).toFixed(2)} {formData.currency}
              </div>
            </div>
          )}
        </div>

        {/* Ödeme Notları */}
        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ödeme Notları
          </label>
          <textarea
            rows={3}
            value={formData.paymentNotes}
            onChange={(e) => handleInputChange('paymentNotes', e.target.value)}
            className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${
              errors.paymentNotes ? 'border-red-300' : 'border-gray-300'
            }`}
            placeholder="Ödeme ile ilgili notlar..."
          />
          {errors.paymentNotes && (
            <p className="mt-1 text-sm text-red-600">{errors.paymentNotes}</p>
          )}
        </div>

        {/* Ödeme Durumu Uyarıları */}
        {formData.paymentStatus === 'partial' && formData.paidAmount >= formData.price && (
          <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
            <p className="text-sm text-yellow-800">
              Ödenen tutar toplam tutara eşit veya büyük. Ödeme durumunu "Ödendi" olarak değiştirmeyi düşünün.
            </p>
          </div>
        )}

        {formData.paymentStatus === 'paid' && formData.paidAmount < formData.price && (
          <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="text-sm text-red-800">
              Ödeme durumu "Ödendi" olarak işaretlenmiş ancak ödenen tutar toplam tutardan az.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentInfo;
